import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateServiceProvider } from 'src/features/serviceProvider/api/useCreateServiceProvider';
import { LIST_SERVICE_PROVIDERS_RESOURCE } from 'src/features/serviceProvider/api/useListServiceProviders';
import ServiceProviderFormModal from 'src/features/serviceProvider/components/form/ServiceProviderFormModal';
import { organisationMessages } from 'src/features/serviceProvider/utils/messages';
import { ServiceProvider } from 'src/features/serviceProvider/utils/types';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface ServiceProviderFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServiceProvider?: ServiceProvider;
    children?: React.ReactNode;
}

function CreateServiceProviderFormModal<TData>({ className, semantics }: ServiceProviderFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateServiceProvider({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PROVIDERS_RESOURCE] });
            toast({
                title: formatMessage(organisationMessages.createOrganisationSuccess),
                description: formatMessage(organisationMessages.createOrganisationSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <ServiceProviderFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values, parkingId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(organisationMessages.addOrganisationSubtitle)}
        />
    );
}

export default CreateServiceProviderFormModal;
